export function getName(firstName = '', lastName = '') {
	const trimmedFirstName = firstName.trim();
	const trimmedLastName = lastName.trim();

	return [trimmedFirstName, trimmedLastName].filter((e) => e).join(' ');
}

/**
 * clearLocalStorage deletes all data stored locally on clients browser
 * */
export function clearLocalStorage() {
	const crnPromos = localStorage.getItem('crnPromos');
	localStorage.clear();
	localStorage.setItem('crnPromos', crnPromos);
}
